import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=4e2cf925&"
import script from "./relations.ts?vue&type=script&lang=js&"
export * from "./relations.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports